var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningPrimaryCircule(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1663 7.00016C14.1663 10.6668 11.1663 13.6668 7.49967 13.6668C3.83301 13.6668 0.833008 10.6668 0.833008 7.00016C0.833008 3.3335 3.83301 0.333496 7.49967 0.333496C11.1663 0.333496 14.1663 3.3335 14.1663 7.00016ZM7.52685 7.56683C7.25071 7.56683 7.02685 7.34298 7.02685 7.06683V5.06683C7.02685 4.79069 7.25071 4.56683 7.52685 4.56683C7.803 4.56683 8.02685 4.79069 8.02685 5.06683V7.06683C8.02685 7.34298 7.803 7.56683 7.52685 7.56683ZM7.52864 8.2335C7.85902 8.2335 8.12685 8.50213 8.12685 8.8335C8.12685 9.16487 7.85902 9.4335 7.52864 9.4335H7.52506C7.19468 9.4335 6.92685 9.16487 6.92685 8.8335C6.92685 8.50213 7.19468 8.2335 7.52506 8.2335H7.52864Z",
    fill: "#3EC1CF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningPrimaryCircule);
export default __webpack_public_path__ + "static/media/warning-primary-circule.87e75395cc1c319f7c77ed552a439a6e.svg";
export { ForwardRef as ReactComponent };